export default __webpack_public_path__ + "static/media/237.f8814a7e.png";